import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const ExportPageSkeleton: React.FC = () => {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh' }}>
      {/* Export Header Skeleton */}
      <Box 
        sx={{ 
          display: 'flex', 
          width: { xs: '100%', md: '90%' }, 
          gap: { xs: 2, md: 4 }, 
          alignItems: 'center', 
          flexWrap: 'wrap',
          mb: 3
        }}
      >
        {/* Title and Format Selector */}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', minWidth: { xs: '100%', sm: 'auto' } }}>
          <Skeleton variant="text" height={32} sx={{ width: { xs: 120, sm: 180 } }} />
          <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
        </Box>

        {/* Date Range Picker */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: { xs: '100%', sm: 'auto' } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="rectangular" height={36} sx={{ width: { xs: 200, sm: 250 }, borderRadius: 1 }} />
          </Box>
        </Box>
      </Box>

      {/* Column Selector Skeleton */}
      <Box
        sx={{
          width: { xs: '100%', md: '80%' },
          borderRadius: 2,
          p: { xs: 1, sm: 2 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mb: 3,
        }}
      >
        {/* Title and Select All */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Skeleton variant="text" height={24} sx={{ width: { xs: 200, sm: 300 } }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="rectangular" width={20} height={20} />
            <Skeleton variant="text" width={80} height={20} />
          </Box>
        </Box>

        {/* Column Grid */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
            gap: 1,
            maxHeight: 400,
            overflow: 'hidden',
          }}
        >
          {Array.from({ length: 12 }).map((_, index) => (
            <Box 
              key={index} 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                py: 0.5,
                px: 1
              }}
            >
              <Skeleton variant="text" height={20} sx={{ width: { xs: 150, sm: 200 } }} />
              <Skeleton variant="rectangular" width={20} height={20} />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Export Actions Skeleton */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          width: { xs: '100%', md: '90%' }, 
          gap: 1, 
          mt: 3,
          px: { xs: 1, sm: 0 }
        }}
      >
        <Skeleton variant="rectangular" width={100} height={42} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );
};